import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { SUPPORT_EMAIL } from '../../shared/links';
import styles from './SupportEmailCard.css';

const cx = classnames.bind(styles);

const DELAY = 5000;

function SupportEmailCard({ className }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(SUPPORT_EMAIL);

            setCopied(true);
            setTimeout(() => setCopied(false), DELAY);
        } catch (err) {
            console.error('Failed to copy email: ', err);
        }
    };

    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <button type='button' className={classes} onClick={handleCopy}>
            <div className={styles.content}>
                <Icon name='copy' />
                <span>{SUPPORT_EMAIL}</span>
            </div>
            <p className={cx('message', { copied })} role='status'>
                {copied ? 'Support email copied!' : 'Tap to copy email address to contact us.'}
            </p>
        </button>
    );
}

SupportEmailCard.propTypes = {
    className: PropTypes.string
};

SupportEmailCard.defaultProps = {
    className: ''
};

export {
    SupportEmailCard
};
